import React from "react";
import { ExpandedAccordion } from "../../../../shared/components/ui/ExpandedAccordion";
import { SupplierService } from "../../../../shared/services/supplierService";

const StockManagmentExpandRow = ({ item }) => {
  console.log("🚀 ~ StockManagmentExpandRow ~ item:", item)
  const totalValue = item.quantity * item.costPerUnit;
  const totalDoses = item.totalDoses || (item.dosesInVial && item.quantity ? item.dosesInVial * item.quantity : null);
  const remainingDoses = item.remainingDoses ?? totalDoses;
  const [supplierName, setSupplierName] = React.useState(item.supplier?.supplierName || item.supplier?.name || item.supplierName || null);

  React.useEffect(() => {
    if (!supplierName && item.supplierId) {
      SupplierService.getById(item.supplierId)
        .then((res) => {
          const supplier = res?.data || res;
          setSupplierName(supplier.supplierName || supplier.name);
        })
        .catch((err) => console.error("Failed to fetch supplier:", err));
    }
  }, [item.supplierId, supplierName]);

  const sections = [
    {
      id: "basic",
      title: "Basic Info",
      fields: [
        { label: "Vaccine Name", value: item.vaccine?.name || item.vaccineName || "—" },
        { label: "Vaccination Center", value: item.vaccinationCenter?.name || item.clinicName || "—" },
        { label: "Batch Number", value: item.batchNumber || "—" },
        { label: "Quantity", value: item.quantity ? `${item.quantity} units` : "—" },
        { label: "Doses In Vial", value: item.dosesInVial ? `${item.dosesInVial} doses` : "—" },
        { label: "Cost Per Unit (₹)", value: item.costPerUnit ? `₹${item.costPerUnit}` : "—" },
        { label: "Total Value (₹)", value: totalValue ? `₹${totalValue}` : "—" },
        { label: "Storage Location", value: item.storageLocation || "—" },
      ],
    },
    {
      id: "inventory",
      title: "Inventory Details",
      fields: [
        { label: "Total Doses", value: totalDoses ? `${totalDoses} doses` : "—" },
        { label: "Remaining Doses", value: remainingDoses ? `${remainingDoses} doses` : "—" },
        { label: "Remaining Full Vials", value: item.remainingFullVials ? `${item.remainingFullVials} vials` : "—" },
        { label: "Open Vial Doses", value: item.openVialDoses ? `${item.openVialDoses} doses` : "—" },
        { label: "Completed Vials", value: item.remainingFullVials && item.quantity ? `${item.quantity - item.remainingFullVials} vials` : "—" },
      ],
    },
    {
      id: "storage",
      title: "Storage & Dates",
      fields: [
        { label: "Manufacturer", value: supplierName || "—" },
        {
          label: "Manufacturing Date",
          value: item.manufacturingDate
            ? new Date(item.manufacturingDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "—",
        },
        {
          label: "Expiry Date",
          value: item.expiryDate
            ? new Date(item.expiryDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "—",
        },
        {
          label: "Received Date",
          value: item.receivedDate
            ? new Date(item.receivedDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "—",
        },
        { label: "Storage Temperature", value: item.temperature || "—" },
        { label: "Condition", value: item.condition || "GOOD" },
        { label: "Notes", value: item.notes || "—", isLong: true },
        { label: "Status", value: item.status || "ACTIVE" },
      ],
    },
  ];

  return <ExpandedAccordion sections={sections} />;
};

export default StockManagmentExpandRow;
